import { SELLER_DATA, STORE_OPEN_STATUS } from '../seller'

export const expirationTime1h = 60 * 60 * 1000

export const parseCookieName = (cookiePart: string): string => {
  const eqPos = cookiePart.indexOf('=')
  return (eqPos > -1 ? cookiePart.slice(0, eqPos) : cookiePart).trim()
}

export const deleteCookie = (name: string): void => {
  window.document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`
}

export const getCookie = (name: string): string | undefined => {
  const match = window.document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`)

  return match?.[2]
}

export const saveCookie = (
  name: string,
  value: string | boolean,
  exp?: number,
  isSecure = false
): void => {
  const secure = isSecure ? 'secure' : ''
  const date = new Date()
  const expVal = exp ?? 7 * 24 * 60 * 60 * 1000 // Expires in 7 days

  if (getCookie(name)) {
    deleteCookie(name)
  }

  date.setTime(date.getTime() + expVal)
  const expires = `expires=${date.toUTCString()}`

  window.document.cookie = `${name}=${value};Path=/;${expires};${secure}`
}

export const clearCookies = (): void => {
  const cookies = window.document.cookie.split(';')

  for (const cookie of cookies) {
    const name = parseCookieName(cookie)

    if (!name) {
      continue
    }

    deleteCookie(name)
  }
}

export const clearSellerData = (): void => {
  localStorage.removeItem(SELLER_DATA)
  localStorage.removeItem(STORE_OPEN_STATUS)
}
